import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import axios from 'axios';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { DateCell, NumberCell } from '../../../../utils/Cells';

class SalaryHistory extends Component {
    state = {
        salaryHistory: []
    }

    componentDidMount() {
        console.log(this.props.row);
        this.callApi(this.props.row.employee.privateId)
            .then(res => this.enrich(res.data))
            .catch(err => console.log(err));
    }

    enrich = (data) => {
        // data.map((item) => {
        // item.dateDate = (item.date) ? f.format(new Date(item.date)) : "";
        //     return item;
        // })
        console.log(data);
        this.setState({ salaryHistory: data.salaryHistory })
    }

    callApi = async (id) => {
        const path = `/api/salaryhistory/${id}`;
        const response = await axios.get(path);
        if (response.status !== 200) throw Error(response.message);
        return response;
    };

    render() {
        return (
            <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Dátum</TableCell>
                            <TableCell>Új bruttó</TableCell>
                            <TableCell>Új nettó</TableCell>
                            <TableCell>Comment</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.state.salaryHistory.map(s => {
                            return <TableRow key={s.privateId}>
                                <TableCell><DateCell value={s.date} /></TableCell>
                                <TableCell><NumberCell value={s.grossSalary} /></TableCell>
                                <TableCell><NumberCell value={s.netSalary} /></TableCell>
                                <TableCell>{s.comment}</TableCell>
                            </TableRow>
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
}

export default withSnackbar(SalaryHistory);
